/** Encode each segment of a path under /live2d/<pack>/ for use in fetch/model URLs. */
export function encodeLive2dRelativePath(relPath) {
  return String(relPath || '')
    .replace(/\\/g, '/')
    .split('/')
    .filter(Boolean)
    .map((s) => encodeURIComponent(s))
    .join('/');
}

export function buildLive2dModelUrlFromParts(publicBase, pack, modelPath) {
  const p = String(pack || '').trim();
  const m = String(modelPath || '').trim();
  if (!p || !m) return '';
  const base = publicBase || '';
  return `${base}/live2d/${encodeURIComponent(p)}/${encodeLive2dRelativePath(m)}`;
}
